// === Adresse du backend : SOURCE UNIQUE ===
// Ne changer l'adresse du backend qu'ici (ou dans env/.env.* via VITE_BACKEND_ORIGIN).
// En dev : requetes via le proxy Vite (baseURL relative) -> evite CORS + probleme de certificat.
// En prod (build) : requetes directes vers l'origine du backend.
const BACKEND_ORIGIN = import.meta.env.VITE_BACKEND_ORIGIN ?? 'http://localhost:8080'
const baseURL = import.meta.env.DEV ? '' : BACKEND_ORIGIN
const websocketURL = import.meta.env.DEV
  ? 'ws://localhost:3000/api/v1/ws'
  : BACKEND_ORIGIN.replace(/^http/, 'ws') + '/api/v1/ws'

export const CURRENT_CONFIG = {

  // license
  appId: '179569', // You need to go to the development website to apply.
  appKey: 'b5cb74c2141fac4169c6a7b90e24859', // You need to go to the development website to apply.
  appLicense: 'CjZv9rzKAok1jIsGYvtDCgvKSeUR+qTCWAA4WCTX/eQqqq4oqwks9EcRkD48RaXMQjlLS2r0+sXOtszpzjj5IxtLNOcGYWchrloipCFrdrb0Mq8dD4YbKYwaKj1SlqhH+yEYiChzaQee5ZaUtJ14NyGhy8Ov7sBk6nzQS5VqN9I=', // You need to go to the development website to apply.

  baseURL,
  websocketURL,

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  mapboxToken: 'pk.eyJ1IjoiZXVybHJiIiwiYSI6ImNtbmdmMWJrMDAyeGgyd3MwZDhvbnk3aHMifQ.wZ9mQ6xF89zbPKNv-E1Vjg',

}
